<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: 6rem !important;">
    <div v-if="showLoading" class="mx-4">
      <custom-skeleton size="large" :count="7" />
    </div>
    <div v-else class="mx-4">
      <vs-divider><h5>Courses</h5></vs-divider>
      <student-module-progress
        id="new-ui__module-progress-component"
        :progressPopupData="progressData"
        :currentStudentId="currentStudentId"
        :logbooksForModules="logbooksForModules"
        :courseProgressStucture="courseProgressStucture"
        :newUIProp="true"
        :showLoadingForModules="showLoadingForModules"
        :isActive="!showLoadingForModules"
      />
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import StudentModuleProgress from '@/components/studentdashboard/menucomponents/StudentModuleProgress.vue';
export default {
  components: {
    CustomSvg,
    StudentModuleProgress
  },
  data() {
    return {
      showLoading: false,
      progressData: [],
      logbooksForModules:[],
      courseProgressStucture:[],
      currentStudentId: null,
      showLoadingForModules: false,
    };
  },
  methods: {
    getProgressData(){
      var self = this;

      self.showLoading = true;

      var onSuccess = response =>{
        self.progressData = response.data;
      }
    
      var onFinally = response =>{
        self.showLoading = false;
        self.getActionableTasks();
      }
    
      self.$ajaxGet(self, "Course/GetCourseProgressOverview", onSuccess, onFinally);
    },
    getActionableTasks(){
      var self = this;
      self.showLoadingForModules = true;
      var onSuccess = response =>{
        self.courseProgressStucture = response.data;
        self.showLoadingForModules = false;
      }

      if(self.progressData){
        var sendData = self.progressData.filter(x=>x.actionNeeded);
        if(sendData){
          self.$ajaxPost(self, "Course/GetActionableTasks", sendData, onSuccess);
        }
      }
    },
    selectedCourseHandler(courseData){
      var self = this;
      if(courseData.actionNeeded || !courseData.courseComplete){
        self.$router.push({ name: "Gen2StudentProfile", params: { CourseProgress: courseData.courseName }});
      }
    },
  },
  mounted() {
    var self = this;
    self.currentStudentId = localStorage.getItem('Current_User_Id');
    self.getProgressData();
    
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>
<style lang="scss">
#new-ui__module-progress-component{
  .module-item{
    text-align: left !important;
    background-color: rgba(255,255,255,0.1);
    border-radius: 20px;
  }
  .open-item{
    .vs-collapse-item--content{
      max-height: fit-content !important;
    }
    .con-content--item{
      padding: 0 !important;
    }
  }
  .action-task {
    cursor: pointer;
    background-color: rgba(255,255,255,0.1);
    border-radius: 15px;
    padding: 8px 12px 8px 12px; //top | right | bottom | left
    margin-bottom: 0.9rem;
  }
}
</style>